import { InferType, number, object } from 'yup';
import { Nullable } from '../../../model/common';
import { QuantitySchemaParams, quantitySchema, safeString } from './common';

interface LimitOrderSchemaParams extends QuantitySchemaParams {}

export const limitOrderSchema = (params: LimitOrderSchemaParams) => {
    return object({
        limitPrice: number().required('Limit Price cannot be empty!').typeError('Please input a number.'),
        quantity: quantitySchema(params),
        duration: object({ label: safeString(), value: number() }).required('Duration cannot be empty!'),
        slippage: safeString()
    });
};

export type LimitOrderFormValues = InferType<ReturnType<typeof limitOrderSchema>>;
export type LimitOrderFormInput = Nullable<LimitOrderFormValues>;
